import { P } from 'components/Typography/P'
import React from 'react'
import styled, { css } from 'styled-components'

export const formRequiredNoticeStyles = css``

const FormRequiredNoticeView = styled.div`
	${formRequiredNoticeStyles}
`

export type FormRequiredNoticeProps = {}
export const FormRequiredNotice = () => {
	return (
		<FormRequiredNoticeView>
			<P isErr className='required-notice'>
				* Indicates required field
			</P>
		</FormRequiredNoticeView>
	)
}
